import initSmartFiler from './modules/smartfilter';
import { initClickNoLabBanner } from './modules/labs';
import { initCatalogLabSlider } from './modules/sliders/lab-catalog-slider';

import NoLabBanner from './components/labs/no-lab-banner';
import LabCatalogSlider from './components/market/lab-catalog-slider';

Vue.component(NoLabBanner.name, NoLabBanner);
Vue.component(LabCatalogSlider.name, LabCatalogSlider);

document.addEventListener('DOMContentLoaded', () => {
    initSmartFiler();
    initClickNoLabBanner();
    initCatalogLabSlider();
});
